<template>
  <app-content class="h-panel">
    <div class="h-panel-bar">
      <span class="h-panel-title">凭证明细</span>
      <span class="dark4-color">提示：按 Ctrl + F 键并输入信息可以快速查找。</span>
    </div>
    <div class="margin-right-left margin-top">
      <account-date-choose v-model="accountDate"/>
      <div class="float-right">
        <template v-if="User.role!=='View'">
          <Button :loading="loading" @click="exportExcel">导出当前明细</Button>
          <Button :loading="loading" @click="exportExcelAll">导出全部明细</Button>
        </template>
      </div>
    </div>
    <div class="h-panel-body">
      <table class="header">
        <tr>
          <td style="width: 100px">日期</td>
          <td style="width: 100px">凭证字号</td>
          <td >摘要</td>
          <td style="width: 300px">科目</td>
          <td style="width: 280px">部门</td>
          <td style="width: 280px">往来</td>
          <td align="right" style="width: 130px">借方金额</td>
          <td align="right" style="width: 130px">贷方金额</td>
        </tr>
      </table>
      <table v-if="!datas.length">
        <tr>
          <td colspan="5" class="text-center padding">暂无数据</td>
        </tr>
      </table>
      <table class="details" v-for="data in datas" >
        <tr v-for="d in data.details" :key="d.id">
          <td style="width: 100px">{{data.voucherDate}}</td>
          <td style="width: 100px">{{data.word}}-{{data.code}}</td>
          <td >
            {{d.summary}}
          </td>
          <td style="width: 300px">{{d.subjectName}}</td>
          <td style="width: 280px">{{ getTwoLettersAfterUnderscore1(d.auxiliaryTitle) }}</td>
          <td style="width: 280px">{{ getTwoLettersAfterUnderscore2(d.auxiliaryTitle) }}</td>
          <td align="right" style="width: 130px">{{d.debitAmount|numFormat}}</td>
          <td align="right" style="width: 130px">{{d.creditAmount|numFormat}}</td>
        </tr>
      </table>

      <Pagination v-model="pagination" @change="currentChange" layout="pager" small align="center"/>
    </div>
  </app-content>
</template>

<script>
import Qs from "qs";
import moment from 'moment'
import {mapState} from 'vuex'
import * as XLSX from 'xlsx';
/**
 * 用于实现凭证列表页面的功能。
 * 该组件提供凭证列表展示、筛选、审核、打印、整理断号、批量删除、导入凭证等功能。
 */
export default {
  name: "Voucher",
  data() {
    return {
      datas: [],
      accountDate: null,
      pagination: {
        page: 1,
        total: 0
      },
      loading: false,
      checkAll: false,
      param: [{title: '打印全部', key: 'printAll'}, {title: '打印选中', key: 'printCheck'}]
    };
  },
  watch: {
    checkAll(nval) {
      let data = Array.from(this.datas);
      data.forEach(val => val._checked = nval);
      this.datas = data;
    },
    accountDate() {
      this.pagination.page = 1;
      this.loadList();
    }
  },
  computed: {
    ...mapState(['User', 'currentAccountSets']),
    date() {
      return moment(this.accountDate);
    }
  },
  methods: {

    /**
     * 导出全部表格数据为 Excel 文件。
     */
    exportExcelAll() {
      this.loading = true;
      this.$api.voucher.listByYearMonth({
        year: this.date.year(),
        month: this.date.month() + 1
      }).then(({data}) => {
        this.exportExcel(data);
        this.loading = false;
      }).catch(error => {
        this.$Message.error("获取数据失败");
        this.loading = false;
      });
    },
    /**
     * 导出当前页表格数据为 Excel 文件。
     */
    exportExcel(dataToExport = this.datas) {
      // 定义表头
      const headers = [
        '日期', '凭证字号', '摘要', '科目', '部门', '往来', '借方金额', '贷方金额'
      ];

      // 处理数据
      const data = dataToExport.flatMap(dataItem =>
          dataItem.details.map(d => [
            dataItem.voucherDate,
            `${dataItem.word}-${dataItem.code}`,
            d.summary,
            d.subjectName,
            this.getTwoLettersAfterUnderscore1(d.auxiliaryTitle),
            this.getTwoLettersAfterUnderscore2(d.auxiliaryTitle),
            d.debitAmount,
            d.creditAmount
          ])
      );

      // 合并表头和数据
      const worksheetData = [headers, ...data];

      // 创建工作表
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

      // 创建工作簿
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, '凭证列表');

      // 导出文件
      XLSX.writeFile(workbook, '凭证列表.xlsx');
    },
    /**
     * 处理字符串，根据规则提取相应内容。
     * 若字符串中两个 "_" 中间的内容包含 "BM"，则返回第一个 "_" 后的全部内容；
     * 否则返回空字符串。
     * @param {string} str - 输入的字符串。
     * @returns {string} - 提取后的内容，若不满足条件则返回空字符串。
     */
    getTwoLettersAfterUnderscore1(str) {
      if (!str) return '';
      const firstUnderscoreIndex = str.indexOf('_');
      if (firstUnderscoreIndex === -1) return '';

      const secondUnderscoreIndex = str.indexOf('_', firstUnderscoreIndex + 1);
      if (secondUnderscoreIndex !== -1) {
        const middleContent = str.slice(firstUnderscoreIndex + 1, secondUnderscoreIndex);
        if (middleContent.includes('BM')) {
          return str.slice(firstUnderscoreIndex + 1);
        }
      }

      // 不满足条件时返回空字符串
      return '';
    },
    /**
     * 处理字符串，根据规则提取相应内容。
     * 若字符串中两个 "_" 中间的内容包含 "WL"，则返回第一个 "_" 后的全部内容；
     * 否则返回空字符串。
     * @param {string} str - 输入的字符串。
     * @returns {string} - 提取后的内容，若不满足条件则返回空字符串。
     */
    getTwoLettersAfterUnderscore2(str) {
      if (!str) return '';
      const firstUnderscoreIndex = str.indexOf('_');
      if (firstUnderscoreIndex === -1) return '';

      const secondUnderscoreIndex = str.indexOf('_', firstUnderscoreIndex + 1);
      if (secondUnderscoreIndex !== -1) {
        const middleContent = str.slice(firstUnderscoreIndex + 1, secondUnderscoreIndex);
        if (middleContent.includes('WL')) {
          return str.slice(firstUnderscoreIndex + 1);
        }
      }

      // 不满足条件时返回空字符串
      return '';
    },
    currentChange() {
      this.loadList();
    },
    trigger(key) {
      this[key].call(this);
    },
    printAll() {
      let param = Qs.stringify({year: this.date.year(), month: this.date.month() + 1}, {indices: false});
      window.open(`/api/pfd/voucher?${param}`);
    },
    printCheck() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        let param = Qs.stringify({id: checked.map(value => value.id)}, {indices: false});
        window.open(`/api/pfd/voucher?${param}`);
      } else {
        this.$Message("未选择记录");
      }
    },
    loadList() {
      this.$api.voucher.list({voucher_year: this.date.year(), voucher_month: this.date.month() + 1, page: this.pagination.page}).then(({data}) => {
        this.datas = data.records;
        this.pagination = {
          page: data.current,
          size: data.size,
          total: data.total
        }
      })
    },
    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        this.$api.voucher.delete(data.id).then(() => {
          this.loadList();
        })
      });
    },
    finishingOffNo() {
      this.loading = true;
      this.$api.voucher.finishingOffNo({year: this.date.year(), month: this.date.month() + 1}).then(() => {
        this.loadList();
      }).finally(() => {
        this.loading = false
      });
    },
    batchDelete() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        this.$Confirm("确认删除?").then(() => {
          this.loading = true;
          this.$api.voucher.batchDelete({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
            this.loadList();
          }).finally(() => {
            this.loading = false
          });
        });
      }
    },
    audit() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        this.$Confirm("亲，确认要审核吗?").then(() => {
          this.loading = true;
          this.$api.voucher.audit({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
            this.loadList();
            this.$Message("审核成功！");
          }).finally(() => {
            this.loading = false;
          });
        });
      } else {
        this.$Message("未选择记录");
      }
    },
    cancelAudit() {
      let checked = this.datas.filter(value => value._checked);
      if (checked.length) {
        this.$Confirm("亲，确认要取消审核吗?").then(() => {
          this.loading = true;
          this.$api.voucher.cancelAudit({checked: checked.map(value => value.id), year: this.date.year(), month: this.date.month() + 1}).then(() => {
            this.loadList();
            this.$Message("取消审核成功！");
          }).finally(() => {
            this.loading = false;
          });
        });
      } else {
        this.$Message("未选择记录");
      }
    },
    doUpload() {
      this.$refs.file.click();
    },
    fileChange(e) {
      if (this.$refs.file.files.length) {
        let formData = new FormData();
        formData.append('file', this.$refs.file.files[0]);
        this.loading = true;
        this.$api.voucher.import(formData).then(({data}) => {
          if (data) {
            this.accountDate = data;
          }
          this.$store.dispatch('init');
          this.$Message("亲,导入成功~");
        }).finally(() => {
          this.loading = false;
        });

        this.$refs.file.value = "";
      }
    }
  }
};
</script>
<style lang='less' scoped>
.h-panel-bar {
  display: flex; /* 使用 Flexbox 布局 */
  justify-content: space-between; /* 让子元素两端对齐 */
  align-items: center; /* 垂直居中对齐 */
}
.h-panel-body {
  table {
    width: 100%;
    border-collapse: collapse;

    td {
      padding: 7px;
    }

    &.header {
      background-color: @primary-color;
      color: white;
    }
  }

  .details {
    font-size: 12px;
    margin: 15px 0;
    border: 1px solid @gray2-color;

    .actions {
      text-align: right;
      padding-right: 20px;

      span, a {
        display: none;
      }
    }

    input {
      display: none;

      &.display {
        display: inline-block;
      }
    }

    &-header {
      background-color: @gray3-color;
      color: @dark3-color;
    }

    td, th {
      border-bottom: 1px solid @gray2-color;
    }

    tr:hover:not(.details-header) {
      background-color: #dff7df;
      cursor: pointer;
    }

    &:hover {
      box-shadow: 0 0 10px 0 #dadada;
      border-color: #dadada;

      .actions {
        span, a {
          display: inline-block;
        }
      }

      input {
        display: inline-block;
      }
    }
  }
}
</style>